import { render, staticRenderFns } from "./VPortfolioStage.vue?vue&type=template&id=06c843fb&"
import script from "./VPortfolioStage.vue?vue&type=script&lang=js&"
export * from "./VPortfolioStage.vue?vue&type=script&lang=js&"
import style0 from "./VPortfolioStage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports